<script>
  import NauiInput from "../../../lib/naui/atoms/NauiInput.svelte";
  import NauiTextarea from "../../../lib/naui/atoms/NauiTextarea.svelte";
  import NauiButton from "../../../lib/naui/atoms/NauiButton.svelte";
  import "../../../../static/front/css/lib/astillero/_formAud.css";
  import { onMount } from "svelte";
  import { writable } from "svelte/store";
  import { createEventDispatcher } from "svelte";
  import {maxLenghtInput} from "../../../lib/utils/index";

  const dispatch = createEventDispatcher();
  let showWarning = writable(false);

  export let data;
  export let hasError;
  
  let Evidencias = data.evidencia.map((x) => ({
    archivo: x,
    nombre: x.replace(data.id + "_", ""),
    nuevo: false
  })).filter((x) => x.nombre != "");
  let archivo_subir = [];
  let EvidenciasEliminar = [];

  let datosData = {
    especifico_tipo_pin: data.especifico_tipo_pin,
    especifico_estado: data.especifico_estado,
    especifico_proveedor_certificado_empaque: data.especifico_proveedor_certificado_empaque,
    especifico_cumple_composicion: data.especifico_cumple_composicion,
    especifico_composicion_incorrecta: data.especifico_composicion_incorrecta,
    especifico_cumple_pictograma: data.especifico_cumple_pictograma,
    especifico_cumple_texto_cuidados: data.especifico_cumple_texto_cuidados,
    especifico_observaciones_cumple_cuidados: data.especifico_observaciones_cumple_cuidados,
    especifico_cumple_codigo_sic: data.especifico_cumple_codigo_sic,
    especifico_precio_venta_publico: data.especifico_precio_venta_publico,
    especifico_precio_venta_sap: data.especifico_precio_venta_sap,
    especifico_cumple_pvp: data.especifico_cumple_pvp,
    especifico_cumple_codigo_pum: data.especifico_cumple_codigo_pum,
    especifico_prueba_elongacion_cuello: data.especifico_prueba_elongacion_cuello,
    especifico_testeo_laboratorio: data.especifico_testeo_laboratorio,
    especifico_muestra_segundo_testeo: data.especifico_muestra_segundo_testeo,
    especifico_cantidad_muestras: data.especifico_cantidad_muestras,
    especifico_color_talla: data.especifico_color_talla,
    especifico_estandar_aprobado: data.especifico_estandar_aprobado,
    especifico_observaciones: data.especifico_observaciones,
    ppp_filete_especificacion: data.ppp_filete_especificacion,
    ppp_filete_unidad: data.ppp_filete_unidad,
    ppp_realce_especificacion: data.ppp_realce_especificacion,
    ppp_realce_unidad: data.ppp_realce_unidad,
    ppp_costura_prenda_especificacion: data.ppp_costura_prenda_especificacion,
    ppp_costura_prenda_unidad: data.ppp_costura_prenda_unidad,

    archivo_subir: archivo_subir,
    evidencias: Evidencias,
    evidenciasEliminar: EvidenciasEliminar
  };

  async function archivoSeleccionado_temporal(e) {
    for (let f of e.target.files) {
      archivo_subir.push(f);
      datosData.archivo_subir=archivo_subir;
      Evidencias = [
        ...Evidencias,
        {
          nombre: f.name,
          archivo: data.id + "_" + f.name,
          nuevo: true,
        }
      ];
    }
    datosData.evidencias = Evidencias;
    actualizarDatos();
  }

  function quitar(arc) {
    // Eliminar de archivo_subir
    datosData.archivo_subir = datosData.archivo_subir.filter(file => file.name !== arc.replace(data.id + "_", ""));
    
    // Eliminar de evidencias
    const evidenciaIndex = datosData.evidencias.findIndex(evidencia => evidencia.archivo === arc);
    if (evidenciaIndex !== -1) {
      const evidencia = datosData.evidencias[evidenciaIndex];
      if (!evidencia.nuevo) {
        datosData.evidenciasEliminar.push(evidencia.archivo);
      }
      datosData.evidencias.splice(evidenciaIndex, 1);
    }

    // Eliminar de Evidencias
    Evidencias = Evidencias.filter(evidencia => evidencia.archivo !== arc);
    
    actualizarDatos();
  }

  async function descargarPDF() {
    try {

      const response = await fetch('/auditoria/descargar_reporte_pdf', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ id: data.id })
      });

      if (!response.ok) {
        throw new Error('Error al descargar el PDF');
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `reporte_auditoria_${data.id}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
    } catch (error) {
      alert("Ocurrio un error al descargar el PDF");
    }
  }

  onMount(() => {

    // //empareja el valor a vacio para mostrar que el campo es obligatorio cuando no se ha diligenciado la auditoria
    if (!data.hora_fin_aud && datosData.especifico_prueba_elongacion_cuello === null) {
      datosData.especifico_prueba_elongacion_cuello = "";
    }
    actualizarDatos();
  });

  function actualizarDatos() {
    dispatch("update", { label: "Datos", data: { ...datosData } });
  }

  function formatDecimalInput(event, field) {
    let value = event.target.value;
    value = value.replace(/[^0-9.]/g, '');
    const parts = value.split('.');
    if (parts.length > 2) {
      value = parts[0] + '.' + parts.slice(1).join('');
    }
    if (parts[0].length > 10) {
      parts[0] = parts[0].slice(0, 10);
    }
    if (parts[1] && parts[1].length > 3) {
      parts[1] = parts[1].slice(0, 3);
    }
    value = parts.join('.');
    event.target.value = value;
    datosData[field] = value == ''? null: value;
    actualizarDatos();
  }


  //Validación campos obligatorios
  $: {
    if (
      (datosData.ppp_filete_especificacion==="" || !datosData.ppp_filete_especificacion)  
        ||(datosData.ppp_filete_unidad === ""|| !datosData.ppp_filete_unidad )
        || (datosData.ppp_realce_especificacion === "" || !datosData.ppp_realce_especificacion)
        || (datosData.ppp_realce_unidad === "" || !datosData.ppp_realce_unidad)
        || (datosData.ppp_costura_prenda_especificacion === "" || !datosData.ppp_costura_prenda_especificacion)
        || (datosData.ppp_costura_prenda_unidad === "" || !datosData.ppp_costura_prenda_unidad)
        || datosData.especifico_prueba_elongacion_cuello === ""
      ) {
      showWarning.set(true);
    } else { 
      showWarning.set(false);
    }
  }

  $: {
    if(
      $showWarning
    )
    {
      hasError.update(errors => [...errors, 'Datos Específicos']);
    }else{
      hasError.update(errors => errors.filter(error => error !== 'Datos Específicos'));
    }
    
  }


</script>

<div class="containerMain">
  <div class="containerMainIntScroll">
    <div class="containerSecction">
      <div class="containerDiv">
        <div class="containerDiv">
          <p class="tittle-text">Tipo de pin:</p>
          <select
            class="tipoSelect"
            name="Tipo de pin"
            id=""
            bind:value={datosData.especifico_tipo_pin}
            on:change={actualizarDatos}
          >
            <option
              value=""
              on:click={() => (datosData.especifico_tipo_pin = null)}
            ></option>
            <option class="textradiochecks" value="PIN DURO">Pin duro</option>
            <option class="textradiochecks" value="PIN BLANDO"
              >Pin blando</option
            >
          </select>
        </div>

        <!--TODO: validar si se quita este radiobuttons, actualmente no hace nada-->
        <div class="containerDiv">
          <label class="textradiochecks" for="apinDuro">A</label>
          <input type="radio" name="pinDuro" id="apinDuro" checked disabled />
          <label class="textradiochecks" for="rpinDuro">R</label>
          <input type="radio" name="pinDuro" id="rpinDuro" disabled />
        </div>
      </div>

      <div class="containerItem">
        <div class="containerDiv">
          <div class="containerTextChecks">
            <p class="tittle-text">Proveedor Certificado por Empaque:</p>
            <div class="containerChecks">
              <div class="radiochecks">
                <input
                  type="radio"
                  name="certi"
                  id="siCerti"
                  bind:group={datosData.especifico_proveedor_certificado_empaque}
                  value={true}
                  on:change={actualizarDatos}
                />
                <label class="textradiochecks" for="siCerti">SI</label>
              </div>
              <div class="radiochecks">
                <input
                  type="radio"
                  name="certi"
                  id="noCerti"
                  bind:group={datosData.especifico_proveedor_certificado_empaque}
                  value={false}
                  on:change={actualizarDatos}
                />
                <label class="textradiochecks" for="noCerti">NO</label>
              </div>
            </div>
          </div>

          <div class="containerTextChecks">
            <p class="tittle-text">Cumple Composición:</p>
            <div class="containerChecks">
              <div class="radiochecks">
                <input
                  type="radio"
                  name="cumple_composicion"
                  id="cc_si"
                  bind:group={datosData.especifico_cumple_composicion}
                  value={true}
                  on:change={actualizarDatos}
                />
                <label class="textradiochecks" for="cc_si">SI</label>
              </div>
              <div class="radiochecks">
                <input
                  type="radio"
                  name="cumple_composicion"
                  id="cc_no"
                  bind:group={datosData.especifico_cumple_composicion}
                  value={false}
                  on:change={actualizarDatos}
                />
                <label class="textradiochecks" for="cc_no">NO</label>
              </div>
            </div>
          </div>
        </div>

        <div class="observation">
          <p class="tittle-text">Compisición incorrecta:</p>
          <NauiTextarea
            label=""
            class="styleTextArea"
            bind:value={datosData.especifico_composicion_incorrecta}
            on:input={(e)=>{
              datosData.especifico_composicion_incorrecta = maxLenghtInput(e, 2000);
              actualizarDatos()
            }}
          />
        </div>
      </div>
    </div>

    <div class="containerSecction">
      <div class="containerItem">
        <div class="containerDiv">
          <div class="containerTextChecks">
            <p class="tittle-text">Cumple Pictograma:</p>
            <div class="containerChecks">
              <div class="radiochecks">
                <input
                  type="radio"
                  name="picto"
                  id="sipicto"
                  bind:group={datosData.especifico_cumple_pictograma}
                  value={true}
                  on:change={actualizarDatos}
                />
                <label class="textradiochecks" for="sipicto">SI</label>
              </div>
              <div class="radiochecks">
                <input
                  type="radio"
                  name="picto"
                  id="nopicto"
                  bind:group={datosData.especifico_cumple_pictograma}
                  value={false}
                  on:change={actualizarDatos}
                />
                <label class="textradiochecks" for="nopicto">NO</label>
              </div>
            </div>
          </div>

          <div class="containerTextChecks">
            <p class="tittle-text">Cumple Texto de Cuidados:</p>
            <div class="containerChecks">
              <div class="radiochecks">
                <input
                  type="radio"
                  name="cumpleCuid"
                  id="sicumpleCuid"
                  bind:group={datosData.especifico_cumple_texto_cuidados}
                  value={true}
                  on:change={actualizarDatos}
                />
                <label class="textradiochecks" for="sicumpleCuid">SI</label>
              </div>
              <div class="radiochecks">
                <input
                  type="radio"
                  name="cumpleCuid"
                  id="nocumpleCuid"
                  bind:group={datosData.especifico_cumple_texto_cuidados}
                  value={false}
                  on:change={actualizarDatos}
                />
                <label class="textradiochecks" for="nocumpleCuid">NO</label>
              </div>
            </div>
          </div>
        </div>

        <div class="observation">
          <p class="tittle-text">Observaciones:</p>
          <NauiTextarea
            label=""
            class="styleTextArea"
            bind:value={datosData.especifico_observaciones_cumple_cuidados}
            on:input={(e)=>{
              datosData.especifico_observaciones_cumple_cuidados = maxLenghtInput(e, 2000);
              actualizarDatos();
            }}
          />
        </div>
      </div>
    </div>

    <div class="containerSecction">
      <div class="containerItem">
        <div class="containerDiv">
          <div class="containerTextChecks">
            <p class="tittle-text">Cumple Código SIC:</p>
            <div class="containerChecks">
              <div class="radiochecks">
                <input
                  type="radio"
                  name="codeSic"
                  id="sicodeSic"
                  bind:group={datosData.especifico_cumple_codigo_sic}
                  value={true}
                  on:change={actualizarDatos}
                />
                <label class="textradiochecks" for="sicodeSic">SI</label>
              </div>
              <div class="radiochecks">
                <input
                  type="radio"
                  name="codeSic"
                  id="nocodeSic"
                  bind:group={datosData.especifico_cumple_codigo_sic}
                  value={false}
                  on:change={actualizarDatos}
                />
                <label class="textradiochecks" for="nocodeSic">NO</label>
              </div>
            </div>
          </div>

          <div class="containerTextChecks">
            <p class="tittle-text">Cumple PVP:</p>
            <div class="containerChecks">
              <div class="radiochecks">
                <input
                  type="radio"
                  name="codePvp"
                  id="sicodePvp"
                  bind:group={datosData.especifico_cumple_pvp}
                  value={true}
                  on:change={actualizarDatos}
                />
                <label class="textradiochecks" for="sicodePvp">SI</label>
              </div>
              <div class="radiochecks">
                <input
                  type="radio"
                  name="codePvp"
                  id="nocodePvp"
                  bind:group={datosData.especifico_cumple_pvp}
                  value={false}
                  on:change={actualizarDatos}
                />
                <label class="textradiochecks" for="nocodePvp">NO</label>
              </div>
            </div>
          </div>
        </div>
        <div class="containerDiv">
          <div class="containerTextChecks">
            <NauiInput
              label="Precio Venta Público ($):"
              type="text"
              class="custom-input-file"
              bind:value={datosData.especifico_precio_venta_publico}
              on:input={(e) => formatDecimalInput(e, 'especifico_precio_venta_publico')}
              on:blur={() => {
                datosData.especifico_precio_venta_publico = parseFloat(datosData.especifico_precio_venta_publico).toFixed(3);
                actualizarDatos();
              }}
            />
          </div>
          <div class="containerTextChecks">
            <NauiInput
              label="Precio Venta SAP ($):"
              type="text"
              class="custom-input-file"
              bind:value={datosData.especifico_precio_venta_sap}
              on:input={(e) => formatDecimalInput(e, 'especifico_precio_venta_sap')}
              on:blur={() => {
                datosData.especifico_precio_venta_sap = parseFloat(datosData.especifico_precio_venta_sap).toFixed(3);
                actualizarDatos();
              }}
            />
          </div>
        </div>
      </div>
    </div>

    <div class="containerSecction">
      <div class="containerItem">
        <div class="containerDiv">
          <div class="containerTextChecks">
            <p class="tittle-text">Cumple Código PUM:</p>
            <select
              name="Opciones"
              id=""
              bind:value={datosData.especifico_cumple_codigo_pum}
              on:change={actualizarDatos}
            >
              <option
                value=""
                on:click={() => (datosData.especifico_cumple_codigo_pum = null)}
              ></option>
              <option class="textradiochecks" value={true}>Si</option>
              <option class="textradiochecks" value={false}>No</option>
              <option class="textradiochecks" value={null}>N/A</option>
            </select>
          </div>

          <div class="containerTextChecks {datosData.especifico_prueba_elongacion_cuello === "" ?  "red-border":""}">

            <div>
              <p class="tittle-text">
                Prueba Elongación Cuello:
              </p>
              <br>
              {#if $showWarning && (datosData.especifico_prueba_elongacion_cuello === "")}
                <span class="error-message">Este campo es obligatorio</span>
              {/if} 

            </div>

                
              <select
                name="Opciones"
                id=""
                bind:value={datosData.especifico_prueba_elongacion_cuello}
                on:change={actualizarDatos}
              >
                <option
                  value=""
                  on:click={() =>
                    (datosData.especifico_prueba_elongacion_cuello = null)}
                ></option>
                <option class="textradiochecks" value={true}>A</option>
                <option class="textradiochecks" value={false}>R</option>
                <option class="textradiochecks" value={null}>N/A</option>
              </select>
              

          </div>
        </div>

        <div class="containerDiv">
          <div class="containerTextChecks">
            <p class="tittle-text">Testeo Laboratorio:</p>
            <select
              name="Opciones"
              id=""
              bind:value={datosData.especifico_testeo_laboratorio}
              on:change={actualizarDatos}
            >
              <option class="textradiochecks" value={null}></option>
              <option class="textradiochecks" value="A">A</option>
              <option class="textradiochecks" value="R">R</option>
              <option class="textradiochecks" value="P">P</option>
            </select>
          </div>
          <div class="containerTextChecks">
            <p class="tittle-text">Muestra Segundo Testeo Tejido Punto:</p>
            <select
              name="Opciones"
              id=""
              bind:value={datosData.especifico_muestra_segundo_testeo}
              on:change={actualizarDatos}
            >
              <option
                value=""
                on:click={() =>
                  (datosData.especifico_muestra_segundo_testeo = null)}
              ></option>
              <option class="textradiochecks" value={true}>Si</option>
              <option class="textradiochecks" value={false}>No</option>
              <option class="textradiochecks" value={null}>N/A</option>
            </select>
          </div>
        </div>
      </div>
    </div>

    <div class="containerSecction">
      <div class="containerDiv">
          <div class="containerTextChecks">
            <p class="tittle-text">Estándar Aprobado:</p>
            <select
              name="Opciones"
              id=""
              bind:value={datosData.especifico_estandar_aprobado}
              
              on:change={actualizarDatos}
            >
              <option class="textradiochecks" value={null}></option>
              <option class="textradiochecks" value={true}>Si</option>
              <option class="textradiochecks" value={false}>No</option>
              <option class="textradiochecks" value={null}>N/A</option>
            </select>
          </div>
      </div>
    </div>

    <div class="containerSecction">
      <div class="containerItem">
        <div class="containerDiv">
          <div class="containerTextChecks">
            <NauiInput
              label="Cantidad Muestras:"
              class="custom-input-file"
              type="number"
              bind:value={datosData.especifico_cantidad_muestras}
              on:input={(e)=>{
                datosData.especifico_cantidad_muestras= maxLenghtInput(e, 9);
                actualizarDatos();
              }}
            />
          </div>
          <div class="containerTextChecks">
            <NauiInput
              label="Color Talla:"
              class="custom-input-file"
              type="text"
              bind:value={datosData.especifico_color_talla}
              on:input={(e)=>{
                datosData.especifico_color_talla = maxLenghtInput(e, 255);
                actualizarDatos();
              }}
            />
          </div>
        </div>
        <div class="observation">
          <div class="containerItem">
            <div class="observationVariable">
              <p class="tittle-text">Observaciones:</p>
              <NauiTextarea
                label=""
                class="styleTextArea"
                bind:value={datosData.especifico_observaciones}
                on:input={(e)=>{
                  datosData.especifico_observaciones = maxLenghtInput(e, 2000);
                  actualizarDatos();
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="containerSecction">
      <div class="containerItem">
        <div class="containerDiv">
          <div class="containerTextChecks">
            <p class="text-center">PPP</p>
          </div>
          <div class="containerTextChecks">
            <div class="observationVariable">
              <p class="tittle-text">FILETE</p>
              <NauiInput
                class="pppInputs {!datosData.ppp_filete_especificacion || datosData.ppp_filete_especificacion === "" ? "red-border" : ""}"
                label="Filete TP:"
                type="number"
                min="0"
                bind:value={datosData.ppp_filete_especificacion}
                on:input={(e)=>{
                  datosData.ppp_filete_especificacion = maxLenghtInput(e, 9);
                  actualizarDatos();
                }}
              />
              {#if $showWarning && (!datosData.ppp_filete_especificacion || datosData.ppp_filete_especificacion === "")}
                <p class="error-message">Este campo es obligatorio</p>
              {/if}

              <NauiInput
                class="pppInputs {!datosData.ppp_filete_unidad || datosData.ppp_filete_unidad === "" ? "red-border" : ""}"
                label="Filete Galga:"
                type="number"
                min="0"
                bind:value={datosData.ppp_filete_unidad}
                on:input={(e)=>{
                  datosData.ppp_filete_unidad= maxLenghtInput(e, 9);
                  actualizarDatos();
                }}
              />
              {#if $showWarning && (!datosData.ppp_filete_unidad || datosData.ppp_filete_unidad === "")}
                <p class="error-message">Este campo es obligatorio</p>
              {/if}


            </div>
          </div>
        </div>
        <div class="containerDiv">
          <div class="containerTextChecks">
            <div class="observationVariable">
              <p class="tittle-text">REALCE</p>
              <NauiInput
                class="pppInputs {!datosData.ppp_realce_especificacion || datosData.ppp_realce_especificacion === "" ? "red-border" : ""}"
                label="Realce TP:"
                type="number"
                min="0"
                bind:value={datosData.ppp_realce_especificacion}
                on:input={(e)=>{
                  datosData.ppp_realce_especificacion = maxLenghtInput(e, 9);
                  actualizarDatos();
                }}
              />
              {#if $showWarning && (!datosData.ppp_realce_especificacion || datosData.ppp_realce_especificacion === "")}
                <p class="error-message">Este campo es obligatorio</p>
              {/if}
              

              <NauiInput
                class="pppInputs {!datosData.ppp_realce_unidad || datosData.ppp_realce_unidad === "" ? "red-border" : ""}"
                label="Realce Galga:"
                type="number"
                min="0"
                bind:value={datosData.ppp_realce_unidad}
                on:input={(e)=>{
                  datosData.ppp_realce_unidad= maxLenghtInput(e, 9);
                  actualizarDatos();
                }}
              />
              {#if $showWarning && (!datosData.ppp_realce_unidad || datosData.ppp_realce_unidad === "")}
                <p class="error-message">Este campo es obligatorio</p>
              {/if}
            </div>
          </div>
          <div class="containerTextChecks">
            <div class="observationVariable">
              <p class="tittle-text">COSTURA</p>
              <NauiInput
                class="pppInputs {!datosData.ppp_costura_prenda_especificacion || datosData.ppp_costura_prenda_especificacion === "" ? "red-border" : ""}"
                label="Costura TP:"
                type="number"
                min="0"
                bind:value={datosData.ppp_costura_prenda_especificacion}
                on:input={(e)=>{
                  datosData.ppp_costura_prenda_especificacion = maxLenghtInput(e, 9);
                  actualizarDatos();
                }}
              />
              {#if $showWarning && (!datosData.ppp_costura_prenda_especificacion || datosData.ppp_costura_prenda_especificacion === "")}
                <p class="error-message">Este campo es obligatorio</p>
              {/if}
              <NauiInput
                class="pppInputs {!datosData.ppp_costura_prenda_unidad || datosData.ppp_costura_prenda_unidad === "" ? "red-border" : ""}"
                label="Costura Galga:"
                type="number"
                min="0"
                bind:value={datosData.ppp_costura_prenda_unidad}
                on:input={(e)=>{
                  datosData.ppp_costura_prenda_unidad= maxLenghtInput(e, 9);
                  actualizarDatos();
                }}
              />
              {#if $showWarning && (!datosData.ppp_costura_prenda_unidad || datosData.ppp_costura_prenda_unidad === "")}
                <p class="error-message">Este campo es obligatorio</p>
              {/if}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div>
      <tr>
        <th class="tittle-text"> Evidencias </th>
        <td style="text-align:left">
          <div class="evidencias">
            
            <input
              type="file"
              accept=".pdf,.xls,.xlsx,.doc,.docx,.png,.jpg,.jpeg,.bmp,.rar,.zip"
              name={`image_src_${data.id}`}
              id={`image_src_${data.id}`}
              data-id={data.id}
              on:change={archivoSeleccionado_temporal}
              class="custom-input-file"
              multiple
            />
          </div>
          <table>
            {#if data.hora_fin_aud != null}
            <tr>
              <td></td>
              <td style="text-align:left">
                <a
                  on:click={() => descargarPDF()}
                  href="#!"
                  >REPORTE_AUDITORIA.PDF
                </a><br />
              </td>
            </tr>
            {/if}
            {#each Evidencias as itemE}
              {#if itemE.nuevo}
                <tr>
                  <td style="text-align:left">
                    <NauiButton
                      icon="disabled_by_default"
                      mode="outline"
                      color="accent"
                      iconStyle="outlined"
                      on:click={() => quitar(itemE.archivo)}
                      on:change={actualizarDatos}
                    />
                  </td>
                  <td style="text-align:left">
                    {itemE.nombre} <br />
                  </td>
                </tr>
              {:else}
                <tr>
                  <td style="text-align:left">
                    <NauiButton
                      icon="disabled_by_default"
                      mode="outline"
                      color="accent"
                      iconStyle="outlined"
                      on:click={() => quitar(itemE.archivo)}
                      on:change={actualizarDatos}
                    />
                  </td>
                  <td style="text-align:left">
                    <a
                      href="/auditoria/descargar?file={itemE.archivo}&nombre={itemE.nombre}"
                      target="blank"
                      >{itemE.nombre}
                    </a><br />
                  </td>
                </tr>
              {/if}
            {:else}
              Debe seleccionar Archivos de evidencia
            {/each}
          </table></td
        >
      </tr>
    </div>
  </div>
</div>

<style>
  :global(.styleTextArea.naui-field) {
    position: relative;
    z-index: 0;
    padding-top: 0.5rem;
    width: 100%;
  }

  :global(.styleTextArea .naui-field-back) {
    width: 100%;
  }

  :global(.styleTextArea .naui-input) {
    width: 100%;
    padding: 0.75rem;
    min-height: 50px;
    height: auto;
    resize: none;
    background-color: white;
  }
  :global(.red-border.naui-field input label) {
    border: 1px solid #ff5a5f;
  }
  :global(.red-border.naui-field.active label) {
    color: red;
  }
  :global(.red-border select) {
    border: 1px solid #ff5a5f;
  }
</style>
